<script setup lang="ts">
import { type NotificationPosition, VNotificationItem, useNotification } from '@/shared/ui'
import './assets/style.scss'
import type { PropType } from 'vue'

defineProps({
  position: {
    type: String as PropType<NotificationPosition>,
    default: 'center',
  },
})

const store = useNotification()
</script>

<template>
  <div class="v-notification__list" :class="`v-notification__list__${position}`">
    <TransitionGroup name="v-notification__trs">
      <VNotificationItem
        v-for="notification in store.notifications"
        :key="notification.id"
        :notification
      />
    </TransitionGroup>
  </div>
</template>
